module.exports = __webpack_public_path__ + "static/images/delete.3tM9LTA.svg";